
import React, { useContext, useEffect, useState } from 'react'
import FileService from '../services/file';
import StorageService from '../services/storage';
import { Context } from "../AppContext";
import { ContextUI } from '../uiContext';
import ViewRoles from '../components/index/rasci/view-roles';
const RasciRolesSearch = (props) => {
    const contextUI = useContext(ContextUI);
    const context = useContext(Context);
 //   const [rasci, setRasci] = useState();
  //  const [selectedRole,setSelectedRole] = useState();

    useEffect(() => {
        contextUI.setTitle('Rollen / taakomschrijving');
        contextUI.setSubTitle('');
     //   contextUI.setShowBackButton(false);

       
            let foundFile = context.info.Index.find(file => {return file.Name == 'rasci.json'});

            if (foundFile) {
                FileService.getContent(foundFile.DPath, StorageService.getStorageFileName(foundFile), true)
                    .then(content => {
                        let obj = (typeof content === 'string') ? JSON.parse(content) : content;
                     //   setRasci(obj);
                        let foundRole = obj.functions.find(role => role.id == props.match.params.number);
                     //   console.log(foundRole);
                      //  foundRole && setSelectedRole(foundRole._id);

                        if(foundRole){
                            props.history.push('/rasci/roles/' + foundFile.DPath + '/' + foundRole._id);
                        }else{
                            props.history.push('/');
                        }
                    })
                    .catch(err => {
                        console.log(err);
                       
                    })
            }
     
    }, [])
return null;
/*
    if (!rasci) return null;
    return (
        <div  >
            <ViewRoles rasci={rasci}  selected={selectedRole}  history={props.history} fileID={props.match.params.id}/>
        </div>
    )
        */
}
export default RasciRolesSearch
